import localization from '@/constant/localization';
import ReceiptCard from '@/components/receipt-card';
import { useTimer } from 'react-timer-hook';
import { useEffect, useState } from 'react';
import { addToTime } from '@/lib/date';
import { useSearchParams } from 'react-router-dom';
import { useGetFinalInvoice } from '@/services/hooks';
import { addQueryString } from '@/lib/helper';
import Container from '@/components/@base/container';
import { COLOR_ENUM, SIZE_ENUM } from '@/components/@base/@types';
import Button from '@/components/@base/button';
import Skeleton from 'react-loading-skeleton';
import { ArrowLeft } from 'iconsax-react';

const Receipt = () => {
  const [disableBtn, setDisableBtn] = useState(false);
  const [searchParams] = useSearchParams();
  const pgc = searchParams.get('pgc');
  const { data, isLoading } = useGetFinalInvoice();
  const redirectUrl = searchParams.get('redirect');
  const { seconds, restart } = useTimer({
    expiryTimestamp: new Date(),
  });
  useEffect(() => {
    const time = addToTime(new Date(), 3, { unit: 'SECONDS' });
    restart(time);
  }, []);
  const goToCommercialUrl = () => {
    location.replace(
      'https://app.ozone.ir/c/campaigns/gift4friends?utm_source=billing&utm_medium=fx-bnr&utm_campaign=RC',
    );
  };
  const redirectToUrl = () => {
    location.replace(
      data?.merchantRedirectURL
        ? addQueryString(data?.merchantRedirectURL, { key: 'pgc', value: pgc })
        : addQueryString(redirectUrl!, { key: 'pgc', value: pgc }),
    );
    setDisableBtn(true);
  };
  return (
    <Container className='flex relative h-[100vh] pt-8 max-w-[448px] w-full mx-auto'>
      {data && (
        <ReceiptCard
          goToCommercialUrl={goToCommercialUrl}
          seconds={seconds}
          data={data}
          setDisableBtn={() => setDisableBtn(true)}
        />
      )}
      {isLoading && (
        <>
          <Container className='w-full px-4'>
            <Skeleton baseColor={'#586066'} className='h-52 w-full dark:bg-grayDark-800' />
          </Container>
          <Container className='fixed bottom-0 w-full max-w-[448px] p-4'>
            <Skeleton baseColor={'#586066'} className='h-12 w-full dark:bg-grayDark-800' />
          </Container>
        </>
      )}
      {data?.merchantRedirectURL && data?.merchantRedirectURL.length > 0 && !isLoading && (
        <Container className='fixed bottom-0 w-full max-w-[448px] p-4'>
          <Button
            color={COLOR_ENUM.PRIMARY}
            size={SIZE_ENUM.XXL}
            className='w-full rounded-full'
            disabled={disableBtn}
            onClick={redirectToUrl}
          >
            {localization.returnToReceivingSite(`${seconds}`)}
          </Button>
        </Container>
      )}

      {data?.merchantRedirectURL.length === 0 && !isLoading && (
        <Container className='fixed bottom-0 w-full max-w-[448px] p-4'>
          <Button
            color={COLOR_ENUM.PRIMARY}
            size={SIZE_ENUM.XXL}
            className='w-full px-3 rounded-full'
            disabled={disableBtn}
            onClick={goToCommercialUrl}
          >
            <Container center className='w-full justify-between'>
              {localization.moreInfo(`${seconds}`)}
              <ArrowLeft size='24' className='text-white' />
            </Container>
          </Button>
        </Container>
      )}
    </Container>
  );
};

export default Receipt;
